import { render, staticRenderFns } from "./PDFViewer.vue?vue&type=template&id=67ae3e66&"
import script from "./PDFViewer.vue?vue&type=script&lang=ts&"
export * from "./PDFViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports